import React from 'react';
import Warning from 'jsx/elements/messages/Warning';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import { splitSsn } from 'utils/strings';

export default function ExclusionRemoval({ data, showSuccess, closeSuccess }) {
  const { t } = useLocale();

  return (
    <div>
      {!showSuccess && (
        <Warning
          messageType="alert"
          messageHeader={t('portfolio_exclusionRemovalModal_confirmRemove_header')}
          messageBody={t(
            'portfolio_exclusionRemovalModal_confirmRemove_body',
            data.name,
            splitSsn(data.payorRegno)
          )}
        />
      )}
      {showSuccess && (
        <Warning
          onClose={closeSuccess}
          messageType="success"
          messageHeader={t('portfolio_exclusionRemovalModal_removeSuccess_title')}
          messageBody={t(
            'portfolio_exclusionRemovalModal_removeSuccess_body',
            data.name,
            splitSsn(data.payorRegno)
          )}
        />
      )}
    </div>
  );
}
